import React, { useEffect } from "react";
import styled from "styled-components";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

const BlockedPermanentlyPage = () => {
    const { logout, token } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        const interval = setInterval(async () => {
            try {
                const res = await fetch("https://boxmealadminapinew.azurewebsites.net/api/auth/details", {
                    method: "GET",
                    headers: { Authorization: `Bearer ${token}` },
                });
                if (!res.ok) return;
                const data = await res.json();
                if (data && data.isBlocked === false) {
                    logout();
                    navigate("/", { replace: true });
                }
            } catch {}
        }, 30000);
        return () => clearInterval(interval);
    }, [logout, navigate, token]);

    const handleCallClick = () => {
        window.location.href = "tel:+46760374616";
    };

    return (
        <Bg>
            <Card>
                <Title>Hoppsan! Ditt konto är visst tillfälligt inaktiverat</Title>
                <Subtitle>
                    Vårt system har tillfälligt pausat ditt konto eftersom vi har identifierat en avvikelse som strider mot våra användarvillkor – till exempel att ett köp inte har registrerats korrekt eller att produkter har tagits utan betalning.
                </Subtitle>
                <SubSection>Vad innebär det?</SubSection>
                <List>
                    <li>Ditt konto är för tillfället inaktiverat</li>
                    <li>Du kan inte använda våra enheter eller genomföra nya köp</li>
                </List>
                <SubSection>Hur kan du lösa detta?</SubSection>
                <Support>
                    Kontakta oss så går vi tillsammans igenom vad som har hänt och hur kontot kan låsas upp.
                    <br />
                    Kontakta vår support på
                    <div>
                        <SupportMail href="mailto:support@ziplink.se">support@ziplink.se</SupportMail>
                    </div>
                </Support>
                <ThanksText>Tack för din förståelse!</ThanksText>
                <Button onClick={handleCallClick}>Kontakta oss för mer info</Button>
            </Card>
        </Bg>
    );
};

export default BlockedPermanentlyPage;

const BASE_FONT = "0.8rem";
const SECTION_FONT = "1rem";
const TITLE_FONT = "1.1rem";


const Bg = styled.div`
    min-height: 100vh;
    width: 100vw;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const Card = styled.div`
    background: #fff;
    padding: 0px 20px 26px 20px;
    border-radius: 20px;
    box-shadow: 0 6px 24px 0 rgba(31,41,55,0.08);
    width: 100%;
    max-width: 370px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;


const Title = styled.h1`
    font-size: ${TITLE_FONT};
    font-weight: 700;
    color: #111;
    margin-bottom: 14px;
    text-align: center;
    line-height: 1.25;
`;

const Subtitle = styled.div`
    color: #232323;
    font-size: ${BASE_FONT};
    text-align: center;
    margin-bottom: 15px;
    line-height: 1.5;
`;

const SubSection = styled.div`
    font-size: ${SECTION_FONT};
    font-weight: 600;
    margin: 10px 0 6px 0;
    text-align: center;
`;

const List = styled.ul`
    font-size: ${BASE_FONT};
    color: #222;
    text-align: left;
    width: 100%;
    margin-bottom: 15px;
    padding-left: 1.15em;
    li {
        margin-bottom: 2px;
        line-height: 1.45;
    }
`;

const Support = styled.div`
    font-size: ${BASE_FONT};
    color: #232323;
    text-align: center;
    margin-bottom: 8px;
    line-height: 1.45;
`;

const ThanksText = styled.div`
    font-size: ${BASE_FONT};
    color: #b6b6b6;
    margin: 10px 0 12px 0;
    text-align: center;
`;


const SupportMail = styled.a`
    color: #111;
    font-weight: 600;
    text-decoration: underline;
    word-break: break-all;
`;

const Button = styled.button`
    width: 100%;
    padding: 15px 0;
    margin: 0 auto 10px auto;
    border-radius: 999px;
    border: 2px solid #111;
    background: #fff;
    color: #111;
    font-size: ${BASE_FONT};
    font-weight: 600;
    cursor: pointer;
    box-shadow: 0 1px 10px 0 rgba(16,24,40,0.04);
    transition: background 0.17s, color 0.17s, border 0.17s, box-shadow 0.17s;
    &:hover, &:focus {
        background: #111;
        color: #fff;
        border: 2px solid #111;
        box-shadow: 0 2px 24px 0 rgba(16,24,40,0.10);
        outline: none;
    }
`;



